/** Chart data shapes and shared styling for the trees report (frontend-design.md §7). */
import { speciesColor } from '@/theme/colors';
import type { SpeciesRow } from './stats';

export { CHART_AXIS_PROPS } from '@/components/charts';

export const SPECIES_BAR_LIMIT = 12;

/**
 * One bar per species. Each row carries its value under its own genus, so a stacked chart
 * with one series per genus paints every bar in its species colour.
 */
export function speciesBars(rows: SpeciesRow[], value: (r: SpeciesRow) => number | null, name: (genus: string) => string) {
  const kept = rows.filter((r) => value(r) !== null).slice(0, SPECIES_BAR_LIMIT);
  return {
    data: kept.map((r) => ({ species: name(r.genus), [r.genus]: value(r)! })) as Record<string, string | number>[],
    series: kept.map((r) => ({ name: r.genus, color: speciesColor(r.genus), label: name(r.genus) })),
  };
}
